import { AuthenticationException, BadRequestException } from '../services/exceptions';
import { post } from './http'

export async function login(email, password, the350club, urlTrial) {
    const response = await post('/auth/login', { email, password, The350Club: the350club, urlTrial });
    if (response.status === 200) {
        return await response.json();
    }
    throw new AuthenticationException((await response.json()).message);
}

export async function refresh(props) {
    // console.log('refresh props:',props)
    const response = await post('/auth/refresh', props);
    if (response.status === 200) {
        return await response.json();
    }
    throw new AuthenticationException((await response.json()).message);
}

export async function confirmAccount(confirmInfo, email) {
    const response = await post('/auth/confirm', {
        Username: email,
        Code: confirmInfo.confirmCode
    });
    if (response.status === 200) {
        return await response.json();
    }
    throw new BadRequestException((await response.json()).message);
}

export async function forgotPassword(email) {
    const response = await post('/auth/reset', {
        Username: email
    });
    if (response.status === 200) {
        return await response.json();
    }
    throw new BadRequestException((await response.json()).message);
}

export async function setNewPassword(email, confirmCode, password) {
    const response = await post('/auth/resetconfirm', {
        Username: email,
        ResetCode: confirmCode,
        Password: password
    });
    if (response.status === 200) {
        return await response.json();
    }
    throw new BadRequestException((await response.json()).message);
}

export async function resendConfCode(email) {
    const response = await post('/auth/resendconfirm', {
        Username: email
    });
    if (response.status === 200) {
        return await response.json();
    }

    throw new BadRequestException((await response.json()).message);
}

export async function getSpecialUserFeatures(specialUser) {
    // NB: specialUser must match a backend Core.Enums.SpecialUserEnum name - "The350Club" or "UrlTrial"
    const response = await post(`/auth/specialUserFeatures/${specialUser}`);
    if (response.status === 200) {
        return await response.json();
    }

    throw new BadRequestException((await response.json()).message);
}
